// import bannerTextEn from '../../assets/images/image_banner_text_en.png'
'use strict';
export default {
    appName: 'PhotoSir',
    errorCode: {
        code12: 'Token Error',
        code115: 'Account does not exist',
        code117: 'Password error',
        code118: 'Mobile phone number format error',
        code123: 'Verification code error',
    },
    // components---------------------------------------------------------------------------------------------------
    login: {
        codeLogin: 'Verification code login',
        accountLogin: 'Account password login',
        inputPhone: 'Please enter email',
        inputCode: 'Please enter verification code',
        getCode: 'Get verification code',
        login: 'Login',
        inputAccount: 'Please enter account',
        inputPassword: 'Please enter password',
        thirdPartyLogin: 'Third party login',
        loginAgreement: 'By logging in, you agree to ',
        agreement: 'PhotoSir software license and service agreement',
        Refund: 'Refund Policy',
        and: ' and ',
        policy: 'Privacy Policy',
        privacyPolicyUrl: '/static/privacy_policy_en.html',
        RefundPolicyUrl: '/static/refund_policy_en.html',
        userAgreementUrl: '/static/user_agreement_en.html',
        close: 'Close',
        charactersLong: '6-50  characters',
        accountCannotBeEmpty: 'Account cannot be empty',
        loginSucceeded: 'Login succeeded',
        codeError: 'Verification code error!',
        tip: 'Tips',
        logoutTip: 'This operation will logout, do you want to continue?',
        confirm: 'determine',
        cancel:'cancel',
        accountError: 'Account error!',
        personalCenter: "Personal Center",
        LogOut:'Log out !'
    },
    userCenter: {
        url: 'https://user.yeeheart.com/#/front/Personal/PersonalInformation?token='
    },
};



// WEBPACK FOOTER //
// ./src/language/config/en.js